export default __webpack_public_path__ + "static/media/(71).8f8c3f61.jpg";